import mdx from "modax";

mdx.plugin(
  "imgPre",
  function() {
    this._data.url = arguments[0];
    this.on("click", (evt) => {
      if (evt.target.className === "img-pre-close") {
        this.close();
      }
    });
  },
  {
    template: `
    <div class='img-pre'>
        <img _src='url'>
        <span class='img-pre-close'/>
    </div>
    `,
    url: "",
  }
);
